import React, { useEffect, useState } from 'react';
// @ts-ignore
import Modal from '@atlaskit/modal-dialog';
// @ts-ignore
import Button, { ButtonGroup } from '@atlaskit/button';
import get from 'lodash/get';
import './version-selector-modal.less';

import {
    translatableText
    // @ts-ignore
} from '../../utils/translatable-text';

const PRODUCT_NAME_SELECTOR = 'meta[name="product-name"]';
const PAGE_TYPE_SELECTOR = 'meta[name="page-type"]';
const PAGE_NAME_SELECTOR = 'meta[itemprop="name"]';
const APP_NAME_SELECTOR = 'meta[name="app-name"]';
// @ts-ignore
export const VersionSelectorModal = ({
    version,
    close,
    spaceId
}: {
    version: string;
    close: () => void;
    spaceId: string;
}) => {
    const [searchParams, setSearchParams] = useState('');

    useEffect(() => {
        // FRAK-847
        const rawPageType = get(
            document.querySelector(PAGE_TYPE_SELECTOR),
            'content',
            ''
        );
        const sanitizedPageType =
            rawPageType === 'Guide' ? 'Documentation' : rawPageType;

        const productName = document.querySelector(PRODUCT_NAME_SELECTOR)
            ? get(document.querySelector(PRODUCT_NAME_SELECTOR), 'content', '')
            : get(document.querySelector(APP_NAME_SELECTOR), 'content', '');

        const queryParams = [];
        queryParams.push(`productName=${encodeURIComponent(productName)}`);
        queryParams.push(`pageType=${encodeURIComponent(sanitizedPageType)}`);
        queryParams.push(`productVersion=${version}`);
        queryParams.push(
            `queryString=${encodeURIComponent(
                get(document.querySelector(PAGE_NAME_SELECTOR), 'content', '')
            )}`
        );
        setSearchParams(queryParams.join('&'));
    }, [version]);

    return (
        <Modal
            heading="Unable to find page"
            width="small"
            components={{
                /* eslint-disable-next-line react/display-name */
                Body: () => (
                    <p
                        className="version-modal__body"
                        data-testid="version-modal-body"
                    >
                        This exact page does not exist in our Server {version}{' '}
                        documentation. Would you like to look for an alternative
                        page?
                    </p>
                ),
                /* eslint-disable-next-line react/display-name */
                Footer: () => (
                    <div className="version-modal__footer">
                        <ButtonGroup>
                            <Button
                                href={`http://confluence.atlassian.com/search?${searchParams}`}
                                target="_self"
                            >
                                {translatableText.search.text}
                            </Button>
                            <Button
                                href={`http://confluence.atlassian.com/display/${spaceId}`}
                                target="_self"
                            >
                                {translatableText.browse.text}
                            </Button>
                            <Button
                                appearance="subtle"
                                className="cancel"
                                onClick={close}
                            >
                                {translatableText.cancel.text}
                            </Button>
                        </ButtonGroup>
                    </div>
                )
            }}
        />
    );
};
